import { Component, Input, OnInit } from '@angular/core';
import IZoningCodeMetaData = ZoningAPI.IZoningCodeMetaData;
import { formatNumber } from '@angular/common';

@Component({
    standalone: false,
    selector: 'app-prs-missed-entities-view',
    templateUrl: './prs-missed-entities-view.component.html',
    styleUrls: ['./prs-missed-entities-view.component.scss']
})
export class PrsMissedEntitiesViewComponent implements OnInit {
    @Input()
    zcMetaData: IZoningCodeMetaData;

    formatNumber = formatNumber;

    constructor() {}

    ngOnInit(): void {}

    isRed(fieldName: string) {
        return !!fieldName && !!this.zcMetaData && !!this.zcMetaData[fieldName];
    }
}
